const $ = window.jQuery;

$(() => {
    const $newsletter = $('form.newsletter');

    if (!$newsletter.length) {
        return;
    }

    $newsletter.on('submit', function(e) {
        e.preventDefault();

        const loading = `<div class="aam__loading"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>`;
        const email = $(this)
            .children()
            .children('.newsletter__email')
            .first()
            .val();
        const url = `${$(this).attr('action')}/${email}`;
        const $message = $(this)
            .children('.newsletter__message')
            .first();

        $message.html(loading);

        $.ajax({
            url,
            type: 'post',
            data: {
                email,
            },
        }).done(res => {
            const text_class =
                res.code === 'subscription_success'
                    ? 'newsletter__message-text--success'
                    : '';
            $message.html(
                `<span class="newsletter__message-text ${text_class}">${
                    res.message
                }</span>`,
            );
        });
    });
});
